import { useAPI } from 'src/services/api';
import AdminAuthContext from 'src/store/admin-auth-context';

const useAdminAPI = () => {
  return useAPI({
    accessTokenUrl: '/admin/accessToken',
    redirectURL: '/admin/login',
    context: AdminAuthContext,
  });
};

export default useAdminAPI;
